import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/api';
export default function CreditorAutocomplete({ value, onChange, onSelect, onBlur }) {
  const [suggestions, setSuggestions] = useState([]);
  const [show, setShow] = useState(false);
  const ref = useRef();
  useEffect(() => {
    if (value && value.length >= 2) {
      const t = setTimeout(() => {
        api.get('/creditor-db/suggest', { params: { q: value } })
          .then(r => { setSuggestions(r.data); setShow(true); }).catch(() => {});
      }, 200);
      return () => clearTimeout(t);
    } else { setSuggestions([]); setShow(false); }
  }, [value]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setShow(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input className="form-input" value={value} onChange={e => onChange(e.target.value)}
        placeholder="Начните вводить название кредитора" onFocus={() => suggestions.length && setShow(true)}
        onBlur={() => onBlur && setTimeout(onBlur, 250)} />
      {show && suggestions.length > 0 && (
        <div style={{ position:'absolute',top:'100%',left:0,right:0,background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:'var(--radius-sm)',zIndex:10,maxHeight:200,overflowY:'auto',boxShadow:'var(--shadow)' }}>
          {suggestions.map((s, i) => (
            <div key={i} style={{ padding:'8px 12px',cursor:'pointer',fontSize:13,borderBottom:'1px solid var(--border)' }}
              onMouseDown={() => { onSelect(s); setShow(false); }}
              onMouseEnter={e => e.target.style.background='var(--bg-hover)'}
              onMouseLeave={e => e.target.style.background='transparent'}>
              <strong>{s.name}</strong>
              {s.inn && <span style={{ color:'var(--text-muted)',marginLeft:8 }}>ИНН: {s.inn}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
